import { render } from "./SetMenuPage.vue?vue&type=template&id=a8a67840"
import script from "./SetMenuPage.vue?vue&type=script&lang=js"
export * from "./SetMenuPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__